import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { useState, useRef } from 'react'
import './index.scss'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

const Contact = () => {
    // Formspree integration active
    const [letterClass, setLetterClass] = useState('text-animate')

    const refForm = useRef()

    setTimeout(() => { setLetterClass('text-animate-hover') }, 4000)




    const sendEmail = (e) => {
        e.preventDefault()

        const formData = new FormData(refForm.current)

        fetch('https://formspree.io/f/xgozvoqg', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        }).then((response) => {
            if (response.ok) {
                alert('Message sent successfully!')
                window.location.reload(false)
            } else {
                alert('Failed to send message, please try again')
            }
        }).catch(() => {
            alert('Failed to send message, please try again')
        })
    }


    return (
        <>

            <div className="container contact-page">
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'U', 'S']}
                            idx={15}
                        />
                    </h1>
                    <p>Bringing your vision from software to reality with mobile software, machine learning and robotics
                    </p>
                    <div className="contact-form">
                        <form ref={refForm} onSubmit={sendEmail}>
                            <ul>
                                <li className="half">
                                    <input placeholder="Name" type="text" name="name" required />
                                </li>
                                <li className="half">
                                    <input
                                        placeholder="Email"
                                        type="email"
                                        name="email"
                                        required
                                    />
                                </li>
                                <li>
                                    <input
                                        placeholder="Subject"
                                        type="text"
                                        name="subject"
                                        required
                                    />
                                </li>
                                <li>
                                    <textarea
                                        placeholder="Message"
                                        name="message"
                                        required
                                    ></textarea>
                                </li>
                                <li className="privacy-check">
                                    <input type="checkbox" name="privacyConstraints" required id="privacy_check" />
                                    <label htmlFor="privacy_check">
                                        I agree to the <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms of Service</a>
                                    </label>
                                </li>
                                <li>
                                    <input
                                        type="submit"
                                        className="flat-button submit"
                                        value="SUBMIT" />
                                </li>
                            </ul>
                        </form>
                    </div>

                </div>
                <div className='info-map'>Vermilion Research
                    <br />
                    ‪(312) 285-0552‬
                    <br />
                    USA
                    <br />
                    <span>info@vermresearch.com</span>
                </div>
                <div className='map-wrap'>
                    <MapContainer center={[37.0902, -95.7129]} zoom={4}>
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        <Marker position={[37.0902, -95.7129]}>
                            <Popup>USA</Popup>

                        </Marker>
                    </MapContainer>
                </div>
            </div>

            <Loader type="ball-scale-multiple" />


        </>
    )
}

export default Contact